import React, { useState, useEffect } from 'react'
import Rbc from 'react-beautiful-calendar'

// import GithubLogo from './assets/github-logo.svg'
import styles from './App.module.css'

const App = () => {
  const [ windowWidth, setWindowWidth ] = useState(window.innerWidth)

  const changeWidthHandler = () => {
    setWindowWidth(window.innerWidth)
  }

  useEffect(() => {
    window.addEventListener('resize', changeWidthHandler)
    return () => window.removeEventListener('resize', changeWidthHandler)

  }, [windowWidth])

  const dateChangeOneHandler = ([date, month, year]) => {
    console.log(`From Calendar 1`)
    console.log(`Date: ${date}-${month}-${year}`)
  }

  const dateChangeTwoHandler = ([date, month, year]) => {
    console.log(`From Calendar 2`)
    console.log(`Date: ${date}-${month}-${year}`)
  }

  const dateChangeThreeHandler = ([date, month, year]) => {
    console.log(`From Calendar 3`)
    console.log(`Date: ${date}-${month}-${year}`)
  }

  return (
    <div className={styles.AppContainer}>
      <div className={styles.AppWrapperOne}>
        <div className={styles.Header}>
          <h1>react-beautiful-calendar</h1>
          <p>A beautiful calendar library for your beautiful react applications.</p>
          <br/>
          <a href="https://github.com/daxter-army/react-beautiful-calendar/" className={styles.ImageLink}>
            <img src="https://raw.githubusercontent.com/daxter-army/react-beautiful-calendar/main/readme-media/github-logo.svg" alt="github-logo" className={styles.GithubImage} />
              <span className={styles.NameTag}><b>Docs | Github Repository</b></span>
          </a>
          </div>
          <Rbc variant='singleX' onDateChange={dateChangeTwoHandler}/>
      </div>
      <div className={styles.AppWrapperTwo}>
        <Rbc variant='default' onDateChange={dateChangeOneHandler}/>
        { windowWidth > 1337 && <Rbc variant='default' onDateChange={dateChangeOneHandler}/> }
        <Rbc variant='singleY' onDateChange={dateChangeThreeHandler}/>
      </div>
      <footer className={styles.Footer}><a className={styles.FooterLink} href="https://github.com/daxter-army">Mehul Singh Teya | @daxter-army</a></footer>
    </div>
  )
}

export default App